import messageJson from "../constants/message.json";
import confirmJson from "../constants/confirm.json";
export function formatMessage(message: string, ...args: any[]): string {
    return message?.replace(/{(\d+)}/g, (match, index) => {
        return typeof args[index] !== 'undefined' ? args[index] : '';
    });
}

export default function getMessage(messageKey: string, ...args: any[]): string {
    const message = getMessageByKey(messageKey);

    return formatMessage(message, ...args);
}

function getMessageByKey(messageKey: string): string {
    return MESSAGE[messageKey as keyof typeof MESSAGE] || '';
}

const MESSAGE = messageJson;


export const MESSAGE_VALIDATION = {
    MESSAGE_1: '希望下限価格が希望上限価格未満です。',
};

export const CONFIRM_PROPS = confirmJson;